<script setup>
import { ref } from 'vue'
import BasicAutocompleteInput from '~/components/custom-formkit/BasicAutocompleteInput.vue'

const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Type to search your landlord ...',
  },
  class: {
    type: String,
    default: '',
  },
})

const styleClass = props.class
const store = useLandlordStore()

const inputValue = ref(props.context.value)

const fetchSuggestions = async (queryString) => {
  await store.fetchLandlords(queryString)
  return store.landlords.map((item) => item.name)
}
</script>

<template>
  <BasicAutocompleteInput :context="context" :fetch-function="fetchSuggestions" :placeholder="placeholder" :class="styleClass" />
</template>
